import { fg } from '@atlassian/jira-feature-gating';

const getForgeQuery = () =>
	`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;

export const getEcosystemQuery = (includeForgeQuery = true) =>
	`
    ecosystem {
      ${
				fg('remove-ecosystem-iviq')
					? ''
					: `activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }`
			}
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${includeForgeQuery ? getForgeQuery() : ''}
    }
`;

export const getLegacyRightWebPanelsQuery = () => `
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;
